import API from './API';

const API_VERSION = 'v1';
const PREFIX = `${API_VERSION}/admin/tour/`;
const ADMIN_PREFIX = `${API_VERSION}/admin/`;
const PUBLIC_PREFIX = `${API_VERSION}/public`;
const GAME_PREFIX = `${API_VERSION}/admin/game`;

class TreedisAdminDAO extends API {
  constructor() {
    super();
    const parent = this.public;

    this.public = {
      /** Virtual Staging */
      getTourVSObjects: (tourId: number, { ...options } = {}) => parent.get({ url: `${PREFIX}${tourId}/vstaging`, ...options }),
      getTourVSImages: (slug: string, { ...options } = {}) => parent.get({ url: `${PUBLIC_PREFIX}/${slug}/vstaging-images`, ...options }),
      getTourVSHtmls: (slug: string, options = {}) => parent.get({ url: `${PREFIX}${slug}/vstaging-html`, ...options }),
      getBarriers: (options = {}) => parent.get({ url: `${ADMIN_PREFIX}navigation/barriers`, ...options }),
      getVSSettings: (tourId: number, { ...options } = {}) => parent.get({ url: `${PREFIX}${tourId}/vs-settings`, ...options }),
      getPolygons: (slug: string, { ...options } = {}) => parent.get({ url: `${PREFIX}${slug}/polygons`, ...options }),
      getTourVSVideos: (slug: string, { ...options } = {}) => parent.get({ url: `${PREFIX}${slug}/vstaging-videos`, ...options }),
      getFRFloors: (slug: string, { ...options } = {}) => parent.get({ url: `${PREFIX}${slug}/vs-settings/frfloors`, ...options }),

      getNavigationSweeps: (options = {}) => parent.get({ url: `${ADMIN_PREFIX}navigation/sweeps`, ...options }),
      /** Game * */
      saveAnalytics: ({ ...options } = {}) => parent.post({ url: `${GAME_PREFIX}/analytic/save`, ...options }),

      createPaymentSecret: ({ ...options } = {}) => parent.post({ url: `${PUBLIC_PREFIX}/payment/secret`, ...options }),

      // NAVIGATION
      saveNavigationRating: ({ ...options } = {}) => parent.post({ url: `${ADMIN_PREFIX}navigation/rating`, ...options }),
      sendNavigationLinkSms: ({ ...options } = {}) => parent.post({ url: `${ADMIN_PREFIX}navigation/sms`, ...options }),
      getAllMenuItems: ({ ...options } = {}) => parent.get({ url: `${ADMIN_PREFIX}navigation/menu-items`, ...options }),
      getMenuCategories: ({ ...options } = {}) => parent.get({ url: `${ADMIN_PREFIX}navigation/menu-categories`, ...options }),
      // getMenuFilters: ({ ...options } = {}) => parent.get({ url: `${ADMIN_PREFIX}navigation/menu-filters`, ...options }),
      getNaviationSettings: ({ ...options } = {}) => parent.get({ url: `${ADMIN_PREFIX}navigation/settings`, ...options }),
      getNavigationFinishScreen: ({ ...options } = {}) => parent.get({ url: `${ADMIN_PREFIX}navigation/finish-screen`, ...options }),
      getTeleportGroups: ({ ...options } = {}) => parent.get({ url: `${ADMIN_PREFIX}navigation/teleportGroups`, ...options }),
      getStations: ({ ...options } = {}) => parent.get({ url: `${ADMIN_PREFIX}navigation/stations`, ...options }),
    };
  }
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const DAO = new TreedisAdminDAO().public;

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export default DAO;
